var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 21.5a2.44 2.44 0 0 1-1.766-.717A2.32 2.32 0 0 1 2 19.06v-2.44q0-.518.36-.869.359-.35.89-.35t.89.35q.36.351.36.87v2.44h15v-2.44q0-.519.36-.87.359-.35.89-.35t.89.35.36.87v2.44q0 1.005-.734 1.722a2.44 2.44 0 0 1-1.766.717zm6.25-14.822L8.406 8.965q-.375.366-.89.351a1.3 1.3 0 0 1-.891-.381 1.27 1.27 0 0 1-.36-.854q-.015-.488.36-.854l4.5-4.392a1.1 1.1 0 0 1 .406-.259q.219-.075.469-.076.25 0 .469.076a1.1 1.1 0 0 1 .406.26l4.5 4.391q.375.366.36.854t-.36.854a1.3 1.3 0 0 1-.89.381q-.516.015-.891-.35L13.25 6.677v8.723q0 .518-.36.869-.359.35-.89.35t-.89-.35a1.17 1.17 0 0 1-.36-.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOutline);
export default __webpack_public_path__ + "static/media/upload_outline.527a2123a450436a7f8fc50c7e495beb.svg";
export { ForwardRef as ReactComponent };